// extracted by mini-css-extract-plugin
export default {"socialIcon":"Footer_socialIcon__6pQiL"};